var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAntIco(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 486.576 486.576",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.151,247.487c-62.384-62.384-62.384-163.89,0-226.274L108.938,0c-74.081,74.081-74.081,194.619,0,268.7 L130.151,247.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.425,247.487l21.213,21.213c74.081-74.081,74.081-194.619,0-268.7l-21.213,21.213 C418.809,83.597,418.809,185.103,356.425,247.487z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.436,219.203l21.213-21.213c-16.967-16.967-26.312-39.568-26.312-63.64s9.344-46.672,26.312-63.64l-21.213-21.213 c-22.634,22.633-35.099,52.768-35.099,84.853S135.802,196.569,158.436,219.203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.141,219.203c22.634-22.633,35.099-52.768,35.099-84.853s-12.465-62.219-35.099-84.853L306.928,70.71 c16.967,16.967,26.312,39.568,26.312,63.64s-9.344,46.672-26.312,63.64L328.141,219.203z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.19,180.629c18.224-7.471,31.099-25.395,31.099-46.279c0-27.57-22.43-50-50-50s-50,22.43-50,50 c0,20.883,12.874,38.808,31.098,46.279l-80.258,275.948H85.387v30h315.794v-30H342.44L262.19,180.629z M281.879,355.762 l-77.188,0.007l38.597-132.705L281.879,355.762z M243.288,114.35c11.028,0,20,8.972,20,20s-8.972,20-20,20s-20-8.972-20-20 S232.26,114.35,243.288,114.35z M195.965,385.77l94.638-0.008l20.594,70.815H175.371L195.965,385.77z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntIco);
export default __webpack_public_path__ + "static/media/antIco.383112353ecfcfe9711e3f2a41a4697d.svg";
export { ForwardRef as ReactComponent };